export enum DonorSearchType {
    All = 1,
    Local = 2,
    Remote = 3
}

export const donorSearchTypeList = [
    { id: DonorSearchType.All, description: 'All' },
    { id: DonorSearchType.Local, description: 'Local' },
    { id: DonorSearchType.Remote, description: 'Remote' },
   
];

